$(function () {
  $("a[href*=\\#]:not([href=\\#])").click(function () {
    if (location.pathname == "/account/login" && (this.hash == "#login" || this.hash == "#recover")) {
      return true;
    }

    if (
      location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var $target = $(this.hash);
      $target = ($target.length && $target) || $("[name=" + this.hash.slice(1) + "]");
      if ($target.length) {
        if ($(this).parents(".gNavi").length) {
          setTimeout(function () {
            var targetOffset = $target.offset().top;
            $("html,body").animate({ scrollTop: targetOffset }, 1000);
          }, 100);
        } else {
          var targetOffset = $target.offset().top;
          $("html,body").animate({ scrollTop: targetOffset }, 1000);
        }
        return false;
      }
    }
  });

  var fixstate = false;
  var state = false;
  var scrollpos;
  if (window.innerWidth > 1023) {
    $(".gNavi .innerUl > li a[data-num]").mouseenter(function () {
      var num = $(this).attr("data-num");
      if (fixstate == false) {
        scrollpos = $(window).scrollTop();
        $("body").addClass("fixed").css({ top: -scrollpos });
      }
      fixstate = true;
      $(this).addClass("on");
      $(".subNavi").slideUp();
      $('.subNavi[data-num="' + num + '"]')
        .stop()
        .slideDown(500);
      $(".cover").addClass("on");

      $(".searchInner").slideUp();
      $(".searchBtn").removeClass("active");
    });

    $(".gNavi .innerUl > li a").on("mouseleave", function (evt) {
      if (!$(evt.relatedTarget).closest($(".subNavi")).length) {
        $("body").removeClass("fixed").css({ top: 0 });
        window.scrollTo(0, scrollpos);
        $(".gNavi .innerUl > li a").removeClass("on");
        $(".subNavi").slideUp();
        $(".cover").removeClass("on");
        fixstate = false;
      }
    });

    $(".subNavi").on("mouseleave", function (evt) {
      $("body").removeClass("fixed").css({ top: 0 });
      window.scrollTo(0, scrollpos);
      $(".gNavi .innerUl > li a").removeClass("on");
      $(".subNavi").slideUp();
      $(".cover").removeClass("on");
      fixstate = false;
    });
  }

  $(".searchBtn a").on("click", function () {
    if (fixstate == false) {
      if (window.innerWidth < 1024) {
        if (state == false) {
          scrollpos = $(window).scrollTop();
          $("body").addClass("fixed").css({ top: -scrollpos });
        }
      } else {
        scrollpos = $(window).scrollTop();
        $("body").addClass("fixed").css({ top: -scrollpos });
      }
      $(".searchInner").stop().slideToggle(500);
      $(this).parent().addClass("active");
      $(".cover").addClass("on");
      fixstate = true;

      if (window.innerWidth < 1024) {
        $(".menuBox").removeClass("on");
        $(".menu").removeClass("on");
        $(".subMenu").removeClass("on");
        state = false;
      }
      $(".input-search").focus();
    } else {
      $("body").removeClass("fixed").css({ top: 0 });
      window.scrollTo(0, scrollpos);
      $(".searchInner").stop().slideToggle(500);
      $(this).parent().removeClass("active");
      $(".cover").removeClass("on");
      fixstate = false;
    }
    return false;
  });

  var $dom = $(".searchInner .close span");
  if (window.innerWidth < 1024) {
    $dom = $(".searchInner .close");
  }
  $dom.click(function () {
    $("body").removeClass("fixed").css({ top: 0 });
    window.scrollTo(0, scrollpos);
    $(".searchInner").stop().slideToggle(500);
    $(".searchBtn").removeClass("active");
    $(".cover").removeClass("on");
    fixstate = false;
  });

  if (window.innerWidth > 1023) {
    $(window)
      .scroll(function () {
        if (fixstate == false) {
          if ($(window).scrollTop() > 300) {
            $(".header02").addClass("show");
            $(".suBoxAll").addClass("on");
          } else {
            $(".header02").removeClass("show");
            $(".suBoxAll").removeClass("on");
          }
        }
      })
      .trigger("scroll");
  }

  $(".menu").on("click", function () {
    if (state == false) {
      if (fixstate == false) {
        scrollpos = $(window).scrollTop();
        $("body").addClass("fixed").css({ top: -scrollpos });
      }
      $(".menuBox").addClass("on");
      $(".menu").addClass("on");
      state = true;

      $(".searchInner").slideUp();
      $(".searchBtn").removeClass("active");
      $(".cover").removeClass("on");
      fixstate = false;
    } else {
      $("body").removeClass("fixed").css({ top: 0 });
      window.scrollTo(0, scrollpos);
      $(".menuBox").removeClass("on jsHide");
      $(".menu").removeClass("on");
      $(".subMenu").removeClass("on jsHide");
      state = false;
    }
    return false;
  });

  $(".menuBox .menuNaviUl > li a[data-link]").click(function () {
    var link = $(this).attr("data-link");
    $(".menuBox").addClass("jsHide");
    $('.subMenu[data-menu="' + link + '"]').addClass("on");
    return false;
  });

  $(".menuNaviUl a[data-link2]").click(function () {
    var link2 = $(this).attr("data-link2");
    $(".subMenu[data-menu]").addClass("jsHide");
    $('.subMenu[data-third="' + link2 + '"]').addClass("on");
    return false;
  });

  $(".subMenu[data-third] .back").click(function () {
    $(this).parents(".subMenu").removeClass("on");
    $(".subMenu[data-menu]").removeClass("jsHide");
  });
  $(".subMenu[data-menu] .back").click(function () {
    $(this).parents(".subMenu").removeClass("on");
    $(".menuBox").removeClass("jsHide");
  });

  $("#gFooter .fInner .email input").on("input", function () {
    if ($(this).val()) {
      $(this).attr("placeholder", "");
    } else {
      $(this).attr("placeholder", "E-mail");
    }
  });

  $("#gFooter .fInner .email input").on("focus", function () {
    $(this).parent().addClass("focus");
  });

  $("#gFooter .fInner .email input").on("blur", function () {
    $(this).parent().removeClass("focus");
  });

  var winH;
  $(window)
    .scroll(function () {
      if (window.visualViewport) {
        winH = window.visualViewport.height;
      } else {
        winH = window.innerHeight;
      }
      if ($(window).scrollTop() > 300) {
        $(".pageTop").addClass("show");
      } else {
        $(".pageTop").removeClass("show");
      }

      if ($(window).scrollTop() > $("#gFooter .fBox .fLogo").offset().top - winH) {
        $(".pageTop").addClass("on");
      } else {
        $(".pageTop").removeClass("on");
      }
    })
    .trigger("scroll");
});

$(window).on("load", function () {
  var localLink = window.location + "";
  if (localLink.indexOf("#") != -1 && localLink.slice(-1) != "#") {
    localLink = localLink.slice(localLink.indexOf("#") + 1);
    $("html,body").animate({ scrollTop: $("#" + localLink).offset().top }, 500);
  }
});
